<div class="py-2 px-2 py-md-5 px-md-5">
    <div class="row">
        <div class="col-md-6">
            <mat-card class="bg-white mat-elevation-z3">
                <div class="row">
                    <div class="col-md-6">
                        <mat-card-header>
                            <mat-card-title>
                                <mat-icon class="mx-1" color="primary">directions_car</mat-icon>
                                Dodanie samochodu
                            </mat-card-title>
                            <mat-card-subtitle>Podaj dane samochodu.</mat-card-subtitle>
                        </mat-card-header>
                    </div>
                </div>
                <mat-card-content>
                    <div class="pt-2">
                        <app-car-form #data></app-car-form>
                        <app-form-save-button [invalid]="isSaved || data.carForm.invalid"
                                              (closeForm)="closeForm()"
                                              (save)="addCar()"></app-form-save-button>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>
